//  Services
import { AmssService } from './amss.service';
import { Injectable, EventEmitter } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import 'rxjs/add/operator/map'

@Injectable()
export class ReviewerService extends AmssService {
    public UpdateReviewerEvent$: EventEmitter<any>;

    constructor() {
        super();
        this.UpdateReviewerEvent$ = new EventEmitter<any>();
    }

    public getReviewers() {
        return super.getHttpService()
            .GET(this.apiUrl + '/reviewer/adata/list/' + this.year, true)
            .map(response => response.json());
    }

    public emitReviewerEvent(type, unit) {
        this.UpdateReviewerEvent$.emit({ type: type, data: unit });
    }
}


// WEBPACK FOOTER //
// ./src/app/services/reviewer.service.ts